// extracted by mini-css-extract-plugin
export default {"arrowUpBlock":"UpArrow_arrowUpBlock__WBf94","arrowUp":"UpArrow_arrowUp__MqgxB"};